import React from 'react';
import type { LucideIcon } from 'lucide-react';

type HubIntroStep = {
  title: string;
  description: string;
  Icon: LucideIcon;
};

export const HubIntroCard: React.FC<{
  title: string;
  subtitle: string;
  Icon: LucideIcon;
  steps: HubIntroStep[];
}> = ({
  title,
  subtitle,
  Icon,
  steps
}) => {
  return (
    <div className="mb-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-sm">
      <div className="px-4 py-3 border-b border-slate-200 dark:border-slate-700 flex items-start gap-3">
        <div className="mt-0.5 flex h-9 w-9 items-center justify-center rounded-lg bg-slate-100 dark:bg-slate-700">
          <Icon className="h-5 w-5 text-slate-700 dark:text-slate-200" />
        </div>
        <div className="min-w-0">
          <div className="text-sm font-semibold text-slate-900 dark:text-slate-100">{title}</div>
          <div className="mt-0.5 text-sm text-slate-600 dark:text-slate-300">{subtitle}</div>
        </div>
      </div>
      <div className="p-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {steps.map((step, i) => (
            <div key={`${step.title}-${i}`} className="flex items-start gap-3 rounded-lg border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/60 p-3">
              <div className="mt-0.5 flex h-8 w-8 items-center justify-center rounded-md bg-white dark:bg-slate-700 border border-slate-200 dark:border-slate-600">
                <step.Icon className="h-4 w-4 text-slate-700 dark:text-slate-200" />
              </div>
              <div className="min-w-0">
                <div className="text-sm font-semibold text-slate-900 dark:text-slate-100">{step.title}</div>
                <div className="mt-0.5 text-xs text-slate-600 dark:text-slate-300">{step.description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};



